export type UserChangeEmailRequestDto = {
  email: string;
};

export const initialUserChangeEmailRequestDto: UserChangeEmailRequestDto = {
  email: '',
};
